import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWidth = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M6.80762 6.89062L6.2666 3.64355C6.22122 3.37128 6.40552 3.1139 6.67773 3.06836C6.95012 3.02296 7.20753 3.20711 7.25293 3.47949L7.99316 7.91797C8.03846 8.1903 7.85436 8.44778 7.58203 8.49316L3.14355 9.2334C2.87128 9.27878 2.6139 9.09448 2.56836 8.82227C2.52296 8.54988 2.70711 8.29247 2.97949 8.24707L6.22559 7.70508L0.208984 3.40723L0.791016 2.59277L6.80762 6.89062Z",
		fill: "black"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M11.1924 11.1094L11.7334 14.3564C11.7788 14.6287 11.5945 14.8861 11.3223 14.9316C11.0499 14.977 10.7925 14.7929 10.7471 14.5205L10.0068 10.082C9.96154 9.8097 10.1456 9.55222 10.418 9.50684L14.8564 8.7666C15.1287 8.72122 15.3861 8.90552 15.4316 9.17773C15.477 9.45012 15.2929 9.70753 15.0205 9.75293L11.7744 10.2949L17.791 14.5928L17.209 15.4072L11.1924 11.1094Z",
		fill: "black"
	})]
});
export default SvgWidth;
